// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"aaddf3b4","867":"2ba7a8a9"}[chunkId] + ".chunk.js";
};